import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { auditEventsService } from '@/services/auditEvents';
import type { AuditEventFilters } from '@/types';

export const AUDIT_PAGE_SIZE = 50;

/**
 * One keyset page of audit events for the given cursor. keepPreviousData holds the
 * current page on screen while the next/prev page loads (no flicker in the modal).
 */
export function useAuditEventsPage(filters: AuditEventFilters, cursor: string | null, enabled = true) {
  return useQuery({
    queryKey: ['auditEventsPage', filters, cursor],
    queryFn: () => auditEventsService.getEvents(filters, cursor, AUDIT_PAGE_SIZE),
    enabled,
    staleTime: 15 * 1000,
    placeholderData: keepPreviousData,
  });
}

/**
 * Server-computed facet counts (true totals) for the current filter set. keepPreviousData
 * holds the previous totals/bars/dropdown options on screen while a filter change loads,
 * so they never flash "0 events" / "No data".
 */
export function useAuditFacets(filters: AuditEventFilters, enabled = true) {
  return useQuery({
    queryKey: ['auditFacets', filters],
    queryFn: () => auditEventsService.getFacets(filters),
    enabled,
    staleTime: 15 * 1000,
    placeholderData: keepPreviousData,
  });
}
